import { DashboardComponent } from './dashboard.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/auth/auth.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        children: [
          { path: '', component: DashboardComponent }
        ]
      },
    ])
  ],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/dashboard/dashboard.routing.module.ts